export default "__VITE_ASSET__nN6yb4ZB__"